import React, { FC, ReactNode } from 'react';

import DocumentTitle from '../../components/DocumentTitle';
import { ContainerInner } from '../../common/ContainerInner';

type Props = {
    readonly pageTitle: string;
    readonly cover: ReactNode;
    readonly shortInfo: ReactNode;
    readonly statistics: ReactNode;
    readonly extendedInfo: ReactNode;
    readonly sidebar: ReactNode;
    readonly bottom: ReactNode;
    readonly entryPageItems?: ReadonlyArray<any>;
};

const ProductDetailLayout: FC<Props> = props => {
    const { pageTitle, cover, shortInfo, statistics, extendedInfo, sidebar, bottom } = props;

    return (
        <React.Fragment>
            <DocumentTitle title={pageTitle} />
            <ContainerInner className="product-detail">
                <div className="ca-main">
                    <div className="ca-main-inner">
                        <div className="pd-section">
                            {cover}
                            <div className="pd-details">
                                <div className="pd-details-inner">
                                    {shortInfo}
                                    {statistics}
                                </div>
                                {extendedInfo}
                            </div>
                        </div>
                        {bottom}
                    </div>
                </div>
                {sidebar}
            </ContainerInner>
        </React.Fragment>
    );
};

export default ProductDetailLayout;
